import Joi from 'joi';
import { automationOptionsValidation } from 'components/Template';

const content = Joi.when('type', {
  is: 'SMS',
  then: Joi.string().required()
})
  .when('type', {
    is: 'EMAIL',
    then: Joi.string().allow('')
  })
  .label('Content');

const details = {
  name: Joi.string()
    .label('Template Name')
    .min(3)
    .max(100)
    .required(),
  type: Joi.string()
    .label('Template Type')
    .required(),
  templateDescription: Joi.string()
    .label('Template Description')
    .required(),
  schemaIdentifier: Joi.string()
    .label('Event Type Category')
    .required(),
  headerHeight: Joi.number()
    .label('Header Height')
    .integer()
    .min(0),
  footerHeight: Joi.number()
    .label('Footer Height')
    .integer()
    .min(0)
  // ...automationOptionsValidation
};

const design = {
  id: Joi.string(),
  content: content,
  jsonContent: Joi.any()
};

export default {
  details,
  design,
  all: {
    ...design,
    ...details
  }
};
